import React, { useEffect, useState } from "react";
import { GetUserLoginID, GetUserRole } from "../../Services/UserSessionManager";
import "./KRAEntryScreen.css";
import * as SubStateDB from "../../Services/WeightageDB";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import * as AccountDB from "../../Services/AccountsDB";
import * as ProcessDB from "../../Services/ProcessDB";
import {
  AccountsVM,
  EmployeeTeamVM,
  KRADataVM,
  LabelValueVM,
  ProcessesVM,
  SubStateVM,
  WeightageVM,
} from "../../Models/ViewModels";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { Button, Input, Modal, Pagination, SelectPicker } from "rsuite";
import { toast } from "react-toastify";
import { KRAMtdDisplay } from "./KRAMTDDisplay";
import {
  GetProcessSubstareDropDown,
  GetProductionTargetValue,
} from "../../Services/KRAApprovalDB";

export const KRAEntryScreen = () => {
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [checkDesig, setCheckDesig] = useState(GetUserRole());

  const [cachedEmployeesList, setCachedEmployeesList] = useState(
    new Array<KRADataVM>()
  );
  const [targetData, setTargetData] = useState("");
  const [productionTarget, setProductionTarget] = useState("");
  const [suggestion, setSuggestion] = useState(new Array<AccountsVM>());
  const [accountList, setAccountList] = useState(new Array<LabelValueVM>());

  // const [subState, setSubState] =useState(new Array<SubStateVM>())
  const [subState, setSubState] = useState(new Array<LabelValueVM>());
  const [process, setProcess] = useState(new Array<LabelValueVM>());
  const [KRAData, setKRAData] = useState(new KRADataVM());
  const [rowData, setRowData] = useState(null);
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(
    new Array<KRADataVM>()
  );
  const [noOfRows, setNoOfRows] = useState(1);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [checkSub, setCheckSub] = useState(false);
  const [state, setState] = React.useState();

  const [clickedEdit, setClickedEdit] = useState(false);

  useEffect(() => {
    getAllEntryList(loginid);
    getAccountDetails();
    getProcessDetails();
  }, []);

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const getAllEntryList = (loginid: any) => {
    AccountDB.GetKRAList(loginid)
      .then((res) => {
        if (res.data) {
          setCachedEmployeesList(res.data);
          setFilteredEmployeesList(res.data);
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const getElementByXpath = (path: string) => {
    return document.evaluate(
      path,
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;
  };

  const handleSubmit = (e: any) => {
    let today = new Date();
    if (
      KRAData.SubmittedOn == "" ||
      KRAData.AccountName == "" ||
      KRAData.ProcessName == "" ||
      KRAData.SubStateName == "" ||
      KRAData.ProductionCount == 0
    ) {
      toast.error("Enter Correct Details!");
    } else if (KRAData.SubmittedOn > today.toISOString().substring(0, 10)) {
      toast.error("Date must be less than  or equal to current date!");
    } else {
      console.log(KRAData);
      AccountDB.KRAAdd(KRAData, loginid).then((res) => {
        if (res.data === "Success") {
          getAllEntryList(loginid);
          setKRAData((prevState) => ({
            ...prevState,
            ProductionCount: 0,
          }));
          toast.success("Submitted successfully");
        } else toast.error(res.data);
      });
    }
  };

  const handleUpdate = () => {
    let today = new Date();
    KRAData.SubmittedOn = KRAData.SubmittedOn.split("/").reverse().join("-");
    if (
      KRAData.SubmittedOn == "" ||
      KRAData.AccountName == "" ||
      KRAData.ProcessName == "" ||
      KRAData.SubStateName == "" ||
      KRAData.ProductionCount == 0
    ) {
      toast.error("Enter Correct Details!");
    } else if (KRAData.SubmittedOn > today.toISOString().substring(0, 10)) {
      toast.error("Date must be less than  or equal to current date!");
    } else
      AccountDB.KRAEdit(KRAData, loginid, checkDesig).then((res) => {
        if (res.data == "Success") {
          getAllEntryList(loginid);
          setClickedEdit(false);
          setCheckSub(false);
          setKRAData(new KRADataVM());
          toast.success("Updated successfully");
        } else toast.error("error");
      });
  };

  const handleDelete = (KRAID: number) => {
    if (window.confirm("Are you Sure you want to delete?") == true) {
      AccountDB.DeleteEmployeeScreenDetails(KRAID).then((res) => {
        if (res.data == 1) {
          getAllEntryList(loginid);
          toast.error("Deleted successfully");
        } else toast.error("Error!");
      });
    } else {
      toast.error("Cancelled");
    }
  };

  const getAccountDetails = () => {
    AccountDB.GetAccountDetails()
      .then((res) => {
        if (res.data) {
          setAccountList(
            res.data.map((s: any) => ({
              label: s.AccountName,
              value: s.AccountName,
            }))
          );
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;

    setPage(1);
    if (searchText) {
      setFilteredEmployeesList(
        cachedEmployeesList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setFilteredEmployeesList([...cachedEmployeesList]);
    }
  };

  const getSubState = (Process: string) => {
    SubStateDB.GetSubStateProcess(Process)
      .then((res) => {
        // res.data.map((s:any)=>{substates.push(s.SubStateName+"-"+s.CaseType+"-"+s.Payer+"-"+s.Action)})
        if (res.data) {
          setSubState(
            res.data.map((s: any) => ({
              label:
                s.SubStateName +
                "-" +
                s.CaseType +
                "-" +
                s.Payer +
                "-" +
                s.Action,
              value: s.SubStateName,
            }))
          );
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };
  const ProcessSubstareDropDown = (
    accountName: string,
    processName: string
  ) => {
    console.log(accountName + " " + processName);
    GetProcessSubstareDropDown(accountName, processName)
      .then((res) => {
        console.log(res.data);
        if (res.data) {
          setSubState(
            res.data.map((s: any) => {
              console.log(s.caseType);
              if (s.caseType != "")
                return {
                  label: s.SubStateName + "-" + s.caseType,
                  value: s.SubStateName,
                };
              else return { label: s.SubStateName, value: s.SubStateName };
            })
          );
          // res.data.map((s:any)=>{
          //   setSubState({label:s.SubStateName+"-"+s.caseType,value:s.SubStateName})
          // })
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };
  const handleProcessChange = (event: any) => {
    let value =
      event.target.type === "number" ? +event.target.value : event.target.value;
    setKRAData({ ...KRAData, [event.target.name]: value });
    setCheckSub(true);
    getSubState(value);
  };

  const handlePostState = () => {
    clickedEdit
      ? GetProductionTargetValue(
          loginid,
          KRAData.AccountName,
          KRAData.SubStateName,
          KRAData.ProcessName
        )
          .then((res) => {
            if (res.data) {
              setTargetData("");
              setProductionTarget(res.data);
            }
          })
          .catch((err) => {
            console.log("fail");
          })
      : !checkSub
      ? GetProductionTargetValue(
          loginid,
          KRAData.AccountName,
          KRAData.SubStateName,
          KRAData.ProcessName
        )
          .then((res) => {
            if (res.data) {
              setProductionTarget("");
              setTargetData("");
            }
          })
          .catch((err) => {
            console.log("fail");
          })
      : GetProductionTargetValue(
          loginid,
          KRAData.AccountName,
          KRAData.SubStateName,
          KRAData.ProcessName
        )
          .then((res) => {
            if (res.data) {
              setProductionTarget("");
              setTargetData(res.data);
            }
          })
          .catch((err) => {
            console.log("fail");
          });
  };

  const handleEdit = (row: any) => {
    setClickedEdit(true);
    var rowData: any = row;
    setRowData(rowData.KRAID);
    setKRAData(rowData);
    // getSubState(rowData.ProcessName)
    ProcessSubstareDropDown(rowData.AccountName, rowData.ProcessName);
  };
  const handleChange = (event: any) => {
    let value =
      event.target.type === "number" ? +event.target.value : event.target.value;
    console.log("handlechange" + event.target.value);
    setKRAData({ ...KRAData, [event.target.name]: value });
  };
  if (
    KRAData.AccountName != "" &&
    KRAData.ProcessName != "" &&
    KRAData.SubStateName != ""
  ) {
    handlePostState();
  }

  // const Suggestion=(e:any)=>{
  //   if (e.length > 0) {
  //   var  matches = accountList.filter(user => {
  //     const regex = new RegExp(`${e}`, "gi");
  //     return user.AccountName.match(regex)
  //     })
  //     setSuggestion(matches)

  //     }

  // }

  const getProcessDetails = () => {
    ProcessDB.GetProcessDetails()
      .then((res) => {
        if (res.data) {
          setProcess(
            res.data.map((s: any) => ({
              label: s.ProcessName,
              value: s.ProcessName,
            }))
          );
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const handleChangechk = (value: any, name: any) => {
    console.log(value, name);
    if (name === "SubStateName")
      setKRAData({ ...KRAData, ["SubStateName"]: value });
    else if (name === "AccountName") {
      var accname = value;
      setKRAData({ ...KRAData, ["AccountName"]: value });
      ProcessSubstareDropDown(accname, KRAData.ProcessName);
    } else if (name === "ProcessName") {
      var processname = value;
      setKRAData({ ...KRAData, ["ProcessName"]: value });
      setCheckSub(true);
      //getSubState(value)
      ProcessSubstareDropDown(KRAData.AccountName, processname);
    }
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-8">
          <h4 id="h4">Productivity Entry</h4>
        </div>
        <div className="col-md-3">
          <Input
            className="form-control w-100 border border-dark"
            placeholder="Search..."
            type={"search"}
            id="search"
            onChange={handleFilterData}
          />
        </div>
        <div className="col-md-1">
          <button
            id="color"
            onClick={() => handleDownloadAsExcel(cachedEmployeesList)}
          >
            <BootstrapIcon
              bootStrapIconName={"file-earmark-arrow-down-fill"}
              size={35}
              cssClasses={"pe-2"}
            />{" "}
          </button>
        </div>
      </div>
      <br />
      <KRAMtdDisplay />
      <div className="row">
        <div className="col-md-8"> </div>
        <div className="col-md">
          {" "}
          <BootstrapIcon
            bootStrapIconName="clock-fill text-warning"
            size={20}
            cssClasses="me-2"
          />
          <b className="col-md-1">Pending</b>
        </div>
        <div className="col-md">
          {" "}
          <BootstrapIcon
            bootStrapIconName="hand-thumbs-up-fill  text-success"
            size={20}
            cssClasses="me-2"
          />
          <b className="col-md-1">Accepted</b>
        </div>
        <div className="col-md">
          {" "}
          <BootstrapIcon
            bootStrapIconName="hand-thumbs-down-fill  text-danger"
            size={20}
            cssClasses="me-2"
          />
          <b className="col-md">Rejected</b>
        </div>
      </div>

      <div>
        <table id="tab">
          <tr>
            <th id="thDate">Date</th>
            <th id="thAcc">Account</th>
            <th id="thProc">Process</th>
            <th id="thSub">SubState-CaseType-Payer-Action</th>
            <th id="thPro">Production #</th>
            <th id="thTarget">Target</th>
            <th id="thRem">Remarks</th>
            <th id="thAct">Actions</th>
            <th id="thProc1">Production%</th>
            <th id="thStat">Status</th>
            <th id="thApp">Approved By</th>
            <th id="thOn">Approved On</th>
          </tr>
        </table>
      </div>
      <table id="tab">
        {[...Array(noOfRows)].map((elementInArray, index) => {
          return (
            <tr>
              <td id="date" className="firstRow">
                <input
                  type="date"
                  className="firstRow"
                  placeholder="dd-mm-yyyy"
                  min="01-01-1997"
                  max="31-12-2080"
                  id="date"
                  name="SubmittedOn"
                  onChange={handleChange}
                />
              </td>
              <td id="Account" className="firstRow">
                {/* <select className="firstRow"id="Account" name="AccountName"  onChange={handleChange}>
          <option>Select Account</option>
          {
                    accountList.map(account=>{
                        if(account===null)  
                        return<></>
                        else  if(account.IsActive==="Active") 
                       
                        return(
                            <option value={account.AccountName}>{account.AccountName}</option>
                    )})
          }
          
          </select> */}
                <SelectPicker
                  data={accountList}
                  size="xs"
                  appearance="subtle"
                  placeholder="Account"
                  onChange={(value, event) =>
                    handleChangechk(value, "AccountName")
                  }
                  style={{ width: 133, backgroundColor: "yellow" }}
                />
              </td>
              <td id="Process" className="firstRow">
                {/* <select id="Process" className="firstRow"  name="ProcessName" onChange={handleProcessChange}> 
               <option >Select Process</option>
          {          
                    process.map(pro=>{
                        if(pro===null)
                        return<></>
                        else if(pro.IsActive==="Active") 
                        return(
                            <option value={pro.ProcessName}>{pro.ProcessName}</option>
                    )})
          }
             </select> */}
                <SelectPicker
                  data={process}
                  size="xs"
                  appearance="subtle"
                  placeholder="Process"
                  onChange={(value, event) =>
                    handleChangechk(value, "ProcessName")
                  }
                  style={{ width: 92, backgroundColor: "yellow" }}
                />
              </td>
              <td id="SubState" className="firstRow">
                {/* <select id="SubState"className="firstRow"   name="SubStateName" onChange={handleChange}> 
               <option>Select SubState</option>
          {
                    subState.map(sub=>{
                        if(sub===null)
                        return<></>
                        else if(sub.Status==="Active") 
                        console.log()
                        return(
                            <option value={sub.SubStateName}>{sub.SubStateName} - {sub.CaseType} - {sub.Payer} - {sub.Action}</option>
                    )})
          }
             </select> */}
                <SelectPicker
                  data={subState}
                  size="xs"
                  appearance="subtle"
                  placeholder="SubState"
                  id="SubState"
                  onChange={(value, event) =>
                    handleChangechk(value, "SubStateName")
                  }
                  style={{ width: 238, backgroundColor: "yellow" }}
                />
              </td>
              <td id="ProdCount" className="firstRow">
                <input
                  id="ProdCount"
                  className="firstRow"
                  name="ProductionCount"
                  value={KRAData.ProductionCount}
                  type="number"
                  onChange={handleChange}
                />
              </td>
              <td id="Target" className="firstRow">
                {targetData}
              </td>
              <td id="Remark">
                <input
                  id="Remark"
                  className="firstRow"
                  name="Remarks"
                  type="text"
                  onChange={handleChange}
                />
              </td>
              <td id="action">
                <div className="d-flex  flex-row gap-1">
                  <button id="bton1" type="button" onClick={handleSubmit}>
                    <BootstrapIcon
                      bootStrapIconName="send-fill text-success"
                      size={17}
                      cssClasses="me-2"
                    />
                  </button>
                </div>
              </td>
              <td id="Prod"></td>
              <td id="Status"></td>
              <td id="AppBy"></td>
              <td id="AppOn"></td>
            </tr>
          );
        })}

        {tableDataFeed.map((acc) => {
          return (
            <tbody>
              {clickedEdit && rowData == acc.KRAID ? (
                <tr>
                  <td id="date">
                    <input
                      type="date"
                      id="date"
                      name="SubmittedOn"
                      value={KRAData.SubmittedOn.split("/").reverse().join("-")}
                      onChange={handleChange}
                    />
                  </td>
                  <td id="Account">
                    {/* <select id="Account" name="AccountName"  value={KRAData.AccountName} onChange={handleChange}>
          <option>Select Account</option>
          {
                    accountList.map(account=>{
                        if(account===null)
            
                        return<></>
                        else  if(account.IsActive==="Active") 
                        return(
                            <option value={account.AccountName}>{account.AccountName}</option>
                    )})
          }        
          </select> */}
                    <SelectPicker
                      data={accountList}
                      size="xs"
                      defaultValue={KRAData.AccountName}
                      placeholder="Account"
                      onChange={(value, event) =>
                        handleChangechk(value, "AccountName")
                      }
                      style={{ width: 133 }}
                    />
                  </td>
                  <td id="Process">
                    {/* <select id="Process"  value={KRAData.ProcessName} name="ProcessName" onChange={handleProcessChange}> 
               <option >Select Process</option>
          {   
                    process.map(pro=>{
                        if(pro===null)
                        return<></>
                        else if(pro.IsActive==="Active") 
                        return(
                            <option value={pro.ProcessName}>{pro.ProcessName}</option>
                    )})
          }
             </select> */}
                    <SelectPicker
                      data={process}
                      size="xs"
                      defaultValue={KRAData.ProcessName}
                      placeholder="Process"
                      onChange={(value, event) =>
                        handleChangechk(value, "ProcessName")
                      }
                      style={{ width: 92 }}
                    />
                  </td>
                  <td id="SubState">
                    {/* <select id="SubState" value={KRAData.SubStateName}  name="SubStateName" onChange={handleChange}> 
               <option >Select SubState</option>
          {
                    subState.map(sub=>{
                        if(sub===null)
                        return<></>
                        else if(sub.Status==="Active") 
                        console.log()
                        return(
                            <option value={sub.SubStateName}>{sub.SubStateName} - {sub.CaseType} - {sub.Payer} - {sub.Action}</option>
                    )})
          }
             </select> */}
                    <SelectPicker
                      data={subState}
                      size="xs"
                      defaultValue={KRAData.SubStateName}
                      placeholder="SubState"
                      onChange={(value, event) =>
                        handleChangechk(value, "SubStateName")
                      }
                      style={{ width: 238 }}
                    />
                  </td>

                  <td id="ProdCount">
                    <input
                      id="ProdCount"
                      name="ProductionCount"
                      value={KRAData.ProductionCount}
                      type="number"
                      onChange={handleChange}
                    />
                  </td>
                  <td id="Target">{productionTarget}</td>

                  <td id="Remark">
                    <input
                      id="Remark"
                      name="Remarks"
                      value={KRAData.Remarks}
                      type="text"
                      onChange={handleChange}
                    />
                  </td>
                  <td id="action">
                    <div className="d-flex  flex-row gap-1">
                      <button id="bton1" type="button" onClick={handleUpdate}>
                        Update
                      </button>
                    </div>
                  </td>
                  <td id="Prod"></td>

                  <td id="Status"></td>
                  <td id="AppBy"></td>
                  <td id="AppOn"></td>
                </tr>
              ) : (
                <tr>
                  <td id="date">{acc.SubmittedOn}</td>
                  <td id="Account">{acc.AccountName}</td>
                  <td id="Process">{acc.ProcessName}</td>
                  <td id="SubState">
                    {acc.SubStateName} - {acc.CaseType} - {acc.Payer} -{" "}
                    {acc.Action}
                  </td>
                  <td id="ProdCount">{acc.ProductionCount}</td>
                  <td id="Target">{acc.ProductionTarget}</td>
                  <td id="Remark">{acc.Remarks}</td>
                  {acc.status == "Pending" ? (
                    <td id="action">
                      <div className="row" id="Action">
                        <div className="col-md-1"></div>
                        <div className="col-md-3">
                          <button id="button" onClick={() => handleEdit(acc)}>
                            <BootstrapIcon
                              bootStrapIconName="pencil-fill text-warning"
                              size={18}
                              cssClasses="me-0"
                            />
                          </button>
                        </div>
                        <div className="col-md">
                          <button
                            id="button"
                            onClick={(event) => handleDelete(acc.KRAID)}
                          >
                            <BootstrapIcon
                              bootStrapIconName="trash text-danger"
                              size={18}
                              cssClasses="me-0"
                            />
                          </button>
                        </div>{" "}
                      </div>
                    </td>
                  ) : (
                    <div></div>
                  )}
                  <td id="Prod">{acc.Productionpercent}</td>
                  <td id="Status">
                    {acc.status == "Accepted" ? (
                      <BootstrapIcon
                        bootStrapIconName="hand-thumbs-up-fill text-success"
                        size={18}
                        cssClasses="me-0"
                      />
                    ) : acc.status == "Pending" ? (
                      <BootstrapIcon
                        bootStrapIconName="clock-fill text-warning"
                        size={18}
                        cssClasses="me-0"
                      />
                    ) : (
                      <BootstrapIcon
                        bootStrapIconName="hand-thumbs-down-fill text-danger"
                        size={18}
                        cssClasses="me-0"
                      />
                    )}
                  </td>
                  <td id="AppBy">{acc.ApprovedBy}</td>
                  <td id="AppOn">{acc.ApprovedOn}</td>
                </tr>
              )}
            </tbody>
          );
        })}
      </table>
      {filteredEmployeesList && (
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={["total", "-", "limit", "|", "pager", "skip"]}
            total={filteredEmployeesList.length}
            limitOptions={[10, 15, 20, 25, 30]}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      )}
    </div>
  );
};
